import type { UrlObject } from 'url'
import type { ReactElement } from 'react'

import SoftLink from './SoftLink'

export default function OptionalSoftLink({
  href,
  children,
  isExternal,
}: {
  children: ReactElement
  href?: string | UrlObject | null
  isExternal?: boolean
}): React.ReactNode {
  return href == null ? (
    children
  ) : (
    <SoftLink href={href} isExternal={isExternal}>
      {children}
    </SoftLink>
  )
}
